import ChatText from './ChatText';
export default ChatText;
